import { useBreakpoint } from '@palmetto/dsm-components';

export function useIsDesktop() {
  const { currentBreakpoint } = useBreakpoint();
  return currentBreakpoint !== 'xs' && currentBreakpoint !== 'sm';
}
